import { brandedKey } from './brandedKey.js';

/**
 * The name somebody last went by in a round, on this device.
 *
 * The same people play again next week, usually from the same phone, and
 * typing your own name every time is the one step in joining that tells you
 * nothing. Kept on the device only: it is a convenience for the person
 * holding it, not something the server needs to know between rounds.
 */
const KEY = brandedKey('lastName');

export function readLastName(maxLength: number): string {
  try {
    return (window.localStorage.getItem(KEY) ?? '').slice(0, maxLength);
  } catch {
    // Storage blocked (private mode, strict settings): just an empty field.
    return '';
  }
}

export function rememberName(name: string): void {
  const trimmed = name.trim();
  if (!trimmed) return;
  try {
    window.localStorage.setItem(KEY, trimmed);
  } catch {
    // Nothing to do: next time the field is empty, as it always used to be.
  }
}
